import { render, staticRenderFns } from "./RegisterValueCopyModal.vue?vue&type=template&id=326b89ba&scoped=true&"
import script from "./RegisterValueCopyModal.vue?vue&type=script&lang=ts&"
export * from "./RegisterValueCopyModal.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterValueCopyModal.vue?vue&type=style&index=0&id=326b89ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b89ba",
  null
  
)

export default component.exports